export const state = {
  // product: undefined,
  // products: []
  chargement: {},
  chargements: [],
  pagination:''
}
